import { useTranslation } from 'react-i18next';
import { Stack } from '@mantine/core';
import StageSection from '@/components/app/deals/steps/forwarding/StageSection';
import VehicleRow from '@/components/app/deals/steps/forwarding/VehicleRow';
import type { ForwardingInfo } from '@/types/deals';

interface InTransitProps {
  readonly info: ForwardingInfo;
}

// Этап «В пути»: ТС/вес, уехавшие от экспедитора, но ещё не прибывшие на терминал (кг).
export default function InTransit({ info }: InTransitProps) {
  const { t } = useTranslation();
  const ongoing = info.ongoingDeliveryInfo;
  const vehicles = ongoing?.vehicles ?? [];
  const delivered = (info.unloadedDeliveryInfo?.unloadedDays?.length ?? 0) > 0;

  // Скрываем этап целиком, пока нет ни машин в пути, ни уже доставленного (нечего показывать).
  if (!vehicles.length && !ongoing?.ongoingWeightKg && !delivered) {
    return null;
  }

  // Машин в пути нет: либо ждём начала, либо всё уже приехало.
  const emptyText = vehicles.length
    ? undefined
    : delivered
      ? t('app.deals.forwarding.transitAllArrived')
      : t('app.deals.forwarding.transitWaiting');

  return (
    <StageSection
      title={t('app.deals.forwarding.ongoing')}
      unit={t('app.deals.forwarding.kg')}
      doneLabel={t('app.deals.forwarding.ongoingDone')}
      done={ongoing?.ongoingWeightKg}
      total={info.loadedDeliveryInfo?.loadedWeightKg}
      count={vehicles.length}
      countLabel={t('app.deals.forwarding.vehiclesShort')}
      emptyText={emptyText}
      compact
    >
      <Stack gap="sm">
        {vehicles.map((v, i) => (
          <VehicleRow key={v.ttnId ?? i} vehicle={v} index={i + 1} />
        ))}
      </Stack>
    </StageSection>
  );
}
